import { AlertTriangle } from 'lucide-react';

/**
 * Slim fixed bar shown only in the demo build (VITE_DEMO=true, baked in by
 * `pnpm build:demo`). Renders nothing in normal/production builds. Fixed to the
 * bottom so it never collides with the header or sidebar across layouts.
 */
export function DemoBanner() {
  if (import.meta.env.VITE_DEMO !== 'true') return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] flex items-center justify-center gap-2 bg-amber-500 px-4 py-1.5 text-center text-xs font-medium text-amber-950 shadow-[0_-1px_4px_rgba(0,0,0,0.15)]">
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
      <span>
        Demo environment — sample data only, resets every night. Please don&apos;t enter real information.
      </span>
    </div>
  );
}
